import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";

const praticaReducer = (state: RootState) => state.pratica;

export const praticaIdPraticaSelector = createSelector(praticaReducer, (state) => {
	return state.idPratica;
});

export const praticaRiprendiSelector = createSelector(praticaReducer, (state) => {
	return state.reopenPratica;
});
